let obj = {
    locales: [],
    image: '',
    link: '',
    status: ''
}
export default obj;